export default function ChatBotDownArrowIco() {
  return (
    <svg
      width="165"
      height="48"
      viewBox="0 0 165 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_560_17491)">
        <path
          d="M35.1861 31.2988C28.5815 42.1742 18.9614 43.8412 12.2643 44L83 44L82.445 20L52.4469 20C47.424 20 40.8231 22.0167 35.1861 31.2988Z"
          fill="white"
        />
        <path
          d="M129.259 31.2988C135.863 42.1742 145.484 43.8412 152.181 44L82.2359 44L82 20L111.998 20C117.021 20 123.622 22.0167 129.259 31.2988Z"
          fill="white"
        />
      </g>
      <path
        d="M78 29.5L83 34.5L88 29.5"
        stroke="#98A2B3"
        stroke-width="1.95524"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_560_17491"
          x="0.264404"
          y="0"
          width="163.916"
          height="48"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-8" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_560_17491"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_560_17491"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
